import { Controller } from "@hotwired/stimulus";
import "../../shared/cally";

export default class extends Controller {
  static values = {
    slotsUrl: String,
    serviceItemId: Number,
  };

  static targets = [
    "calendar",
    "dateField",
    "practitionerField",
    "timeField",
    "slotsFrame",
    "submitButton",
  ];

  dateChanged(event) {
    const date = event.target.value;
    if (!date) return;

    this.dateFieldTarget.value = date;
    this.clearPractitioner();
    this.clearTimeSlot();

    if (this.hasSlotsFrameTarget) {
      this.updateSlotsFrame(date, null);
    }
  }

  practitionerSelected(event) {
    const practitionerId = event.target.value;
    this.practitionerFieldTarget.value = practitionerId;
    this.clearTimeSlot();

    const date = this.dateFieldTarget.value;
    if (date && this.hasSlotsFrameTarget) {
      this.updateSlotsFrame(date, practitionerId);
    }
  }

  slotSelected(event) {
    this.timeFieldTarget.value = event.target.value;
    this.toggleSubmitButton(true);
  }

  // private

  updateSlotsFrame(date, practitionerId) {
    const url = this.buildUrl(date, practitionerId);
    this.slotsFrameTarget.src = url.toString();
  }

  buildUrl(date, practitionerId) {
    const url = new URL(
      this.slotsUrlValue,
      window.location.origin
    );
    url.searchParams.set(
      "service_item_id",
      this.serviceItemIdValue
    );
    url.searchParams.set("date", date);

    if (practitionerId) {
      url.searchParams.set(
        "practitioner_id",
        practitionerId
      );
    }

    return url;
  }

  clearPractitioner() {
    if (this.hasPractitionerFieldTarget) {
      this.practitionerFieldTarget.value = "";
    }
  }

  clearTimeSlot() {
    this.timeFieldTarget.value = "";
    this.toggleSubmitButton(false);

    this.uncheckSlotRadios();
  }

  uncheckSlotRadios() {
    if (!this.hasSlotsFrameTarget) return;

    const radios = this.slotsFrameTarget.querySelectorAll(
      'input[type="radio"]:checked'
    );
    radios.forEach((radio) => {
      radio.checked = false;
    });
  }

  toggleSubmitButton(enabled) {
    if (!this.hasSubmitButtonTarget) return;

    this.submitButtonTarget.disabled = !enabled;
  }
}
